import { useEffect, useState } from 'react';
import { getUserMail, getCompanyId } from 'globalutils/fmUtils';

const basicRequest = {
    displayLength: '15',
    displayStart: '1',
};

const sortColumnMapping = {
    requestDateKey: 'requestDate',
    reportType: 'type',
};

export const useManageScheduling = ({
    fetchSchedulingList,
    fetchVehicles,
    getDrivers,
    vehicles,
    drivers,
}) => {
    const [pagination, setPagination] = useState(false);
    const [request, setRequest] = useState({ ...basicRequest });

    const fetchPaginateApi = 'fetchSchedulingPaginateApi';

    const changeRequest = (fields) => {
        if (fields?.sortCol) {
            const type = fields.sortCol;
            fields.sortCol = sortColumnMapping[type] ?? fields.sortCol;
        }
        setRequest({ ...basicRequest, ...fields });
    };

    useEffect(() => {
        fetchSchedulingList({
            apiId: fetchPaginateApi,
            data: { request: { ...request, fleetManagerEmail: getUserMail(), companyId: getCompanyId() } },
        });
    }, [request]);

    useEffect(() => {
        if (!vehicles.vehicleList.length) {
            fetchVehicles({ apiId: 'fetchVehicles' });
        }
        if (!drivers.data.length) {
            getDrivers({ apiId: 'getDrivers' });
        }
    }, []);

    return {
        request,
        changeRequest,
        pagination,
        setPagination,
        fetchPaginateApi,
    };
};
